var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifactionsloggedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0216 5.15253C9.43581 5.15253 6.52164 8.0667 6.52164 11.6525V14.7834C6.52164 15.4442 6.23997 16.4517 5.90414 17.015L4.65831 19.0842C3.88914 20.3625 4.41997 21.7817 5.82831 22.2584C10.4975 23.8184 15.535 23.8184 20.2041 22.2584C21.515 21.825 22.0891 20.2759 21.3741 19.0842L20.1283 17.015C19.8033 16.4517 19.5216 15.4442 19.5216 14.7834V11.6525C19.5216 8.07753 16.5966 5.15253 13.0216 5.15253Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.625,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0259 5.4666C14.6901 5.3691 14.3434 5.29327 13.9859 5.24993C12.9459 5.11993 11.9492 5.19577 11.0176 5.4666C11.3317 4.66493 12.1117 4.1016 13.0217 4.1016C13.9317 4.1016 14.7117 4.66493 15.0259 5.4666Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2717 22.6484C16.2717 24.4359 14.8092 25.8984 13.0217 25.8984C12.1334 25.8984 11.3101 25.5301 10.7251 24.9451C10.1401 24.3601 9.77173 23.5367 9.77173 22.6484",
    stroke: "#9B9B9B",
    strokeWidth: 1.625,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 5,
    r: 5,
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifactionsloggedin);
export default __webpack_public_path__ + "static/media/notifactionsloggedin.ac3b97c3589d62436423b0e14e860edc.svg";
export { ForwardRef as ReactComponent };